import type { ActionStatus } from '../../../../../hooks/useVehiclesNavigoMachine/types'

import { useMemo } from 'react'

import { NavigoIconButton } from '@/components/Navigo/elements/NavigoIconButton'
import { Tooltip } from '@/components/primitives/Tooltip'
import { CenterOnMap } from '@/icons'

import { useTexts } from '../useTexts'

interface Props {
  permission: ActionStatus | 'disabledNoDevice' | 'disabledNoMarker' | 'disabledLoadingGpsData'
  vehicles: uui.domain.client.UnifiedVehicle[]
  onClick: () => void
}

export function CenterOnMapButton(props: Props) {
  const { permission, vehicles, onClick } = props
  const texts = useTexts()

  const disabled = permission.startsWith('disabled')

  const tooltipTitle = useMemo(() => {
    switch (permission) {
      case 'disabledNoDevice':
        return vehicles.length === 1
          ? texts.disabledNoDevice(
              vehicles[0].hasRoutingLicense ? vehicles[0].vehicle.externalId : '',
            )
          : ''

      case 'disabledLoadingGpsData':
        return texts.disabledLoadingGpsData

      case 'disabledNoMarker':
        return texts.disabledNoMarker

      case 'disabled':
        return texts.disabledNotAvailableInThePast

      default:
        return ''
    }
  }, [texts, permission, vehicles])

  const iconColor = disabled ? '$silver' : '$nightRider'

  return (
    <Tooltip placement="top" disabled={!disabled} title={tooltipTitle}>
      <NavigoIconButton
        onClick={onClick}
        disabled={disabled}
        text={texts.centerOnMap}
        Icon={<CenterOnMap size={16} color={iconColor} />}
        testid="navigo-vehicle-overview-actions-centerOnMap"
      />
    </Tooltip>
  )
}
